import * as React from "react";
import {useEffect, useState} from "react";
import cx from "classnames";
import Link from "../UI/Link";
import Button from "../UI/Button";
import useDocumentLinks from "../../hooks/useDocumentLinks";
import * as styles from "./cookienotification.module.css";

const getCookieLSData = () => {
    if (typeof window === "undefined") {
        return {};
    }

    try {
        const rawData = localStorage.getItem("itsm-cookie-notification");
        if (!rawData) {
            return {};
        }

        return JSON.parse(rawData);
    } catch (error) {
        console.error(error);
        return {};
    }
};

const setCookieLSData = (data) => {
    if (typeof window === "undefined") {
        return;
    }

    localStorage.setItem("itsm-cookie-notification", JSON.stringify(data));
};

const getNotificationWasShown = () => {
    const data = getCookieLSData();
    return data.shown;
};

const setNotificationWasShown = () => {
    const data = getCookieLSData();
    data.shown = true;
    setCookieLSData(data);
};

const CookieNotification = () => {
    const [wasShown, setWasShown] = useState(getNotificationWasShown());
    const [isVisible, setIsVisible] = useState(false);

    const {cookieDocument} = useDocumentLinks();

    const onButtonClick = () => {
        setWasShown(true);
        setNotificationWasShown();
    };

    useEffect(() => {
        setTimeout(() => {
            setNotificationWasShown();
            setIsVisible(true);
        }, 500);
    }, []);

    if (wasShown) {
        return null;
    }

    return (
        <div
            className={cx(styles.cookienotification, {
                [styles.cookienotification_visible]: isVisible,
            })}
        >
            <p className={styles.cookienotification__text}>
                Мы используем куки-файлы, чтобы наш сайт был максимально удобным для вас. Нажимая «Согласен», вы даете
                согласие на их использование в соответствии с нашей{" "}
                <Link to={cookieDocument} withArrow={false} inNewTab className={styles.cookienotification__textLink}>
                    Политикой конфиденциальности
                </Link>
                .
            </p>
            <Button variant="primary" onClick={onButtonClick}>
                Согласен
            </Button>
        </div>
    );
};

export default CookieNotification;
